



let language = function () {
    let languageHeader = document.querySelectorAll(".language-change__header");
    let languageItem = document.querySelectorAll(".language-change__item")

    for (let i = 0; i < languageHeader.length; i++) {
        languageHeader[i].addEventListener("click", languageToggle);
    }

    for (let i = 0; i < languageItem.length; i++) {
        languageItem[i].addEventListener("click", languageChoose);
    }

    function languageToggle() {
        this.parentElement.classList.toggle("active");
    }

    function languageChoose() {
        let text = this.innerText;
        let language = this.closest(".language-change");
        let currentText = this.closest(".language-change")
            .querySelector(".language-change__current");
        currentText.innerText = text;
        language.classList.remove("active");
    }
}


language();